import { createContext } from "react";

export const ModalContext = createContext({
  openEditModal: null, // default-nya null
});